import React,{useState, useEffect} from "react";
import Mobile from "../../assets/resources/mobile.png";
import Mobile1 from "../../assets/resources/mobile1.png";
import Mobile2 from "../../assets/resources/mobile2.png";
import Mobile3 from "../../assets/resources/mobile3.png";

import "react-responsive-carousel/lib/styles/carousel.min.css"; 
import { Carousel } from 'react-responsive-carousel';

function MobileAppCard({isVisible}) {
    const [isAnimated, setIsAnimated] = useState(false);

    useEffect(() => {
      if (isVisible) {
      
        setIsAnimated(true);
      }
    }, [isVisible]);
  return (
    <div className={`p-5 lg:p-2 ${isAnimated ? 'animate-pop-in' : ''}`}>
        <div className='bg-gradient-to-r from-[#D0A2EB] flex flex-row to-[#7C5CD3] rounded-lg'>
            <div className='lg:p-10 lg:px-10 w-2/4 p-5'>
            <h1 className='text-white poppins-bold lg:text-4xl  text-sm '>
            Unleash Your App's Potential with Our Development Section
            </h1>
            <p className='text-white poppins-regular lg:py-5 lg:text-xl text-[10px]'>
            Welcome to our App Development Section, where innovation meets functionality. From concept to deployment, we craft mobile experiences that captivate and engage. Let's build your digital future together.
            </p> 
            </div>
            <div className='w-2/4 pt-5 jutify-center items-center lg:hidden'>
            <Carousel className='select-none flex align-center justify-center w-full  ' centerMode preventScrollOnSwipe transitionTime={1000} autoPlay infiniteLoop interval={5000} showThumbs={false}  showStatus={false}>
            <div className='lg:p-5 ml-3 w-3/4  lg:hidden  '>
                <img src={Mobile1}  alt="mobile app" />

            </div>
            <div className='lg:p-5 ml-3   w-3/4  lg:hidden '>
                <img src={Mobile2}  alt="mobile app" />

            </div>
            <div className='lg:p-5 ml-3  w-3/4  lg:hidden '>
                <img src={Mobile3}  alt="mobile app" />

            </div>

            </Carousel>

            </div>
            

 
            <div className='lg:p-5 p-2 w-2/4  hidden lg:block'>
                <img draggable={false} src={Mobile} className='px-10'  alt="only web" />

            </div>

        </div>
      
    </div>
  )
}

export default MobileAppCard
